module.exports = __webpack_public_path__ + "img/content-null.aa4156a3.png";